import { guardClient } from '../_axios'

const API_USERS = '/users'
/**
 * ユーザーの追加
 * @param request
 * @returns
 */
export type SignupRequestType = {
  email: string
  password: string
  firstName: string
  lastName: string
  authorityCode: 'GENERAL' | 'ADMIN'
  userCode: string
}
export const signUpUser = async (request: SignupRequestType) => {
  const response = await guardClient.post(API_USERS + '/signup', request)
  return response.data
}
